import { useTranslation } from 'react-i18next';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';

interface Props {
  loading?: boolean;
  onCancel: () => void;
}

function DocumentVersionFormActions(props: Props) {
  const { loading, onCancel } = props;
  const { t } = useTranslation();
  const actions = [
    <Button
      buttonText={t('cancel')}
      buttonType={ButtonTypes.secondaryOutlined}
      disabled={loading}
      fullWidth
      leftIcon="close"
      onClick={onCancel}
    />,
    <Button
      buttonText={t('save')}
      buttonType={ButtonTypes.primaryFilled}
      disabled={loading}
      fullWidth
      leftIcon="check"
      type="submit"
    />,
  ];
  return <ActionsRow actions={actions} />;
}

export default DocumentVersionFormActions;
